export default __webpack_public_path__ + "static/Yuffie-f6b0fc437d4f2acca6ed46ddd90c1ec7.png";